import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ServiceGroup } from '@quorum/models/xs-resource';

export interface PendingDeclinedServicesState extends EntityState<ServiceGroup> {}

export const pendingDeclinedServicesAdapter: EntityAdapter<ServiceGroup> = createEntityAdapter<ServiceGroup>({
  selectId: (serviceGroup: ServiceGroup) => serviceGroup.id
});

export const initialState: PendingDeclinedServicesState = pendingDeclinedServicesAdapter.getInitialState({});
export const PendingDeclinedServicesFeatureSelector = createFeatureSelector<any>('vehicleMaintenance');
export const pendingDeclinedServiceSelector = createSelector(
  PendingDeclinedServicesFeatureSelector,
  (state: any) => state.pendingDeclinedServices
);
export const { selectIds, selectEntities, selectAll, selectTotal } = pendingDeclinedServicesAdapter.getSelectors(
  pendingDeclinedServiceSelector
);
